/**
 * @name textContent
 * @description Strip HTML tags from a string and return its text content
 */
export const textContent = (html: string) => {
  const parser = new DOMParser();

  return parser.parseFromString(html, 'text/html').documentElement.textContent;
};
